export const inputLoginStyles = {
    '& .MuiFilledInput-input': {                      
        color: '#4664F6',
    },
    '& .MuiFilledInput-root': {
        borderRadius: 3.5,
    }
}